import { render, staticRenderFns } from "./MedecinDetailFcontinuecreate.vue?vue&type=template&id=4d27b61a&"
import script from "./MedecinDetailFcontinuecreate.vue?vue&type=script&lang=js&"
export * from "./MedecinDetailFcontinuecreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports